import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import Box from '@quintoandar/cozy-core/Box';
import CircularProgress from '@quintoandar/cozy-core/CircularProgress';
import tokens from '@quintoandar/cozy-theme/tokens/js';
import { MOBILE_MAX_SCREEN_SIZE } from 'constants/screen';

export const BoxIndex = styled(Box)`
  pointer-events: ${props => (props.pointerEvents ? 'none' : 'all')};
  padding: 0 ${tokens.alias.spacing.xsmall};
  margin-left: calc(-1 * ${tokens.alias.spacing.xsmall});
  margin-right: calc(-1 * ${tokens.alias.spacing.xsmall});
  overflow-x: hidden;
`;

export const BoxWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;

  @media (max-width: ${MOBILE_MAX_SCREEN_SIZE}px) {
    grid-template-columns: 1fr;
    justify-items: center;
  }
`;

export const HeaderWrapper = styled(Box)`
  border-bottom: 1px dashed ${tokens.alias.color.surface.disabled};
`;

export const CardContentWrapper = styled(Box)`
  width: 100%;
  opacity: ${props => (props.transparency ? '50%' : 1)};
`;

export const Loading = styled(CircularProgress)`
  position: absolute;
  z-index: 99;
`;

const rotate = props => `${props.degrees}deg`;

const scale = props => (props.degrees / 90) % 2 === 0 ? 1 : 16 / 9;

export const CardImage = styled.img`
  pointer-events: none;
  aspect-ratio: 16 / 9;
  width: 100%;
  object-fit: cover;
  transform: rotate(${rotate}) scale(${scale});
`;

export const CardImageModal = styled.img`
  width: 100%;
  transform: rotate(${rotate});
`;

export const DeleteIconWrapper = styled(Box)`
  position: absolute;
  right: 0;
  top: 0;
`;

export const SelectMainIconWrapper = styled(Box)`
  position: absolute;
  left: 0;
  top: 0;
`;

export const RotateIconWrapper = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const Card = styled(Box)`
  width: 100%;
  position: relative;
  border-radius: 8px;
  align-items: center;
  justify-content: center;

  & ${DeleteIconWrapper},
  & ${SelectMainIconWrapper},
  & ${RotateIconWrapper} {
    display: none;
  }

  &:hover ${DeleteIconWrapper},
  &:hover ${SelectMainIconWrapper},
  &:hover ${RotateIconWrapper} {
    display: block;
  }
`;

export const PhotosManagerModal = styled(Modal)`
  max-width: 100%;
  overflow: scroll;
  margin: 5% 5%;
`;

export const DropZoneWrapper = styled(Box)`
  transition: height ease 0.7s;
  overflow: hidden;
  height: ${({ showContent }) => (showContent ? '380px' : 0)};
`;
